<template>
  <div class="layout-settings">
    <el-drawer
      title="布局配置"
      :visible.sync="drawerVisible"
      direction="rtl"
      :before-close="handleClose"
      size="280px"
    >
      <div class="layout-settings-content">
        <!-- 全局主题 -->
        <el-divider content-position="center">全局主题</el-divider>
        <div class="setting-item">
          <div class="setting-label">主题颜色</div>
          <div class="setting-value">
            <el-color-picker
              v-model="themeConfig.primary"
              size="default"
              @change="onColorPickerChange"
            ></el-color-picker>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">深色模式</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isIsDark"
              size="small"
              @change="onAddDarkChange"
            ></el-switch>
          </div>
        </div>

        <!-- 顶栏设置 -->
        <el-divider content-position="center">顶栏设置</el-divider>
        <div class="setting-item">
          <div class="setting-label">顶栏背景</div>
          <div class="setting-value">
            <el-color-picker
              v-model="themeConfig.topBar"
              size="default"
              @change="onBgColorPickerChange('topBar')"
            ></el-color-picker>
          </div>
        </div>
        <div class="setting-item">
          <div class="setting-label">顶栏默认字体颜色</div>
          <div class="setting-value">
            <el-color-picker
              v-model="themeConfig.topBarColor"
              size="default"
              @change="onBgColorPickerChange('topBarColor')"
            ></el-color-picker>
          </div>
        </div>
        <div class="setting-item mt10">
          <div class="setting-label">顶栏背景渐变</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isTopBarColorGradual"
              size="small"
              @change="onTopBarGradualChange"
            ></el-switch>
          </div>
        </div>

        <!-- 菜单设置 -->
        <el-divider content-position="center">菜单设置</el-divider>
        <div class="setting-item">
          <div class="setting-label">菜单背景</div>
          <div class="setting-value">
            <el-color-picker
              v-model="themeConfig.menuBar"
              size="default"
              @change="onBgColorPickerChange('menuBar')"
            ></el-color-picker>
          </div>
        </div>
        <div class="setting-item">
          <div class="setting-label">菜单默认字体颜色</div>
          <div class="setting-value">
            <el-color-picker
              v-model="themeConfig.menuBarColor"
              size="default"
              @change="onBgColorPickerChange('menuBarColor')"
            ></el-color-picker>
          </div>
        </div>
        <div class="setting-item mt14">
          <div class="setting-label">菜单背景渐变</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isMenuBarColorGradual"
              size="small"
              @change="onMenuBarGradualChange"
            ></el-switch>
          </div>
        </div>

        <!-- 分栏设置 -->
        <el-divider
          content-position="center"
          :style="{ opacity: themeConfig.layout !== 'columns' ? 0.5 : 1 }"
          >分栏设置</el-divider
        >
        <div
          class="setting-item"
          :style="{ opacity: themeConfig.layout !== 'columns' ? 0.5 : 1 }"
        >
          <div class="setting-label">分栏菜单背景</div>
          <div class="setting-value">
            <el-color-picker
              v-model="themeConfig.columnsMenuBar"
              size="default"
              @change="onBgColorPickerChange('columnsMenuBar')"
              :disabled="themeConfig.layout !== 'columns'"
            ></el-color-picker>
          </div>
        </div>
        <div
          class="setting-item"
          :style="{ opacity: themeConfig.layout !== 'columns' ? 0.5 : 1 }"
        >
          <div class="setting-label">分栏菜单默认字体颜色</div>
          <div class="setting-value">
            <el-color-picker
              v-model="themeConfig.columnsMenuBarColor"
              size="default"
              @change="onBgColorPickerChange('columnsMenuBarColor')"
              :disabled="themeConfig.layout !== 'columns'"
            ></el-color-picker>
          </div>
        </div>
        <div
          class="setting-item mt14"
          :style="{ opacity: themeConfig.layout !== 'columns' ? 0.5 : 1 }"
        >
          <div class="setting-label">分栏菜单背景渐变</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isColumnsMenuBarColorGradual"
              size="small"
              @change="onColumnsMenuBarGradualChange"
              :disabled="themeConfig.layout !== 'columns'"
            ></el-switch>
          </div>
        </div>
        <div
          class="setting-item mt14"
          :style="{ opacity: themeConfig.layout !== 'columns' ? 0.5 : 1 }"
        >
          <div class="setting-label">分栏菜单鼠标悬停预加载</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isColumnsMenuHoverPreload"
              size="small"
              @change="onColumnsMenuHoverPreloadChange"
              :disabled="themeConfig.layout !== 'columns'"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt11">
          <div class="setting-label">分栏Logo高度(px)</div>
          <div class="setting-value">
            <el-input-number
              v-model="themeConfig.columnsLogoHeight"
              controls-position="right"
              :min="1"
              :max="9999"
              @change="onColumnsLogoHeightChange"
              size="small"
              style="width: 90px; margin-right: 1px"
            ></el-input-number>
          </div>
        </div>
        <div class="setting-item mt11">
          <div class="setting-label">分栏菜单宽度(px)</div>
          <div class="setting-value">
            <el-input-number
              v-model="themeConfig.columnsMenuWidth"
              controls-position="right"
              :min="1"
              :max="9999"
              @change="onColumnsMenuWidthChange"
              size="small"
              style="width: 90px; margin-right: 1px"
            ></el-input-number>
          </div>
        </div>
        <div class="setting-item mt11">
          <div class="setting-label">分栏菜单高度(px)</div>
          <div class="setting-value">
            <el-input-number
              v-model="themeConfig.columnsMenuHeight"
              controls-position="right"
              :min="1"
              :max="9999"
              @change="onColumnsMenuHeightChange"
              size="small"
              style="width: 90px; margin-right: 1px"
            ></el-input-number>
          </div>
        </div>

        <!-- 界面设置 -->
        <el-divider content-position="center">界面设置</el-divider>
        <div
          class="setting-item"
          :style="{ opacity: themeConfig.layout === 'transverse' ? 0.5 : 1 }"
        >
          <div class="setting-label">菜单水平折叠</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isCollapse"
              :disabled="themeConfig.layout === 'transverse'"
              size="small"
              @change="onThemeConfigChange"
            ></el-switch>
          </div>
        </div>
        <div
          class="setting-item mt15"
          :style="{ opacity: themeConfig.layout === 'transverse' ? 0.5 : 1 }"
        >
          <div class="setting-label">菜单手风琴</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isUniqueOpened"
              :disabled="themeConfig.layout === 'transverse'"
              size="small"
              @change="setLocalThemeConfig"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">固定 Header</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isFixedHeader"
              size="small"
              @change="onIsFixedHeaderChange"
            ></el-switch>
          </div>
        </div>
        <div
          class="setting-item mt15"
          :style="{ opacity: themeConfig.layout !== 'classic' ? 0.5 : 1 }"
        >
          <div class="setting-label">经典布局分割菜单</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isClassicSplitMenu"
              :disabled="themeConfig.layout !== 'classic'"
              size="small"
              @change="onClassicSplitMenuChange"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">自动锁屏</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isLockScreen"
              size="small"
              @change="setLocalThemeConfig"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt11">
          <div class="setting-label">自动锁屏倒计时(s)</div>
          <div class="setting-value">
            <el-input-number
              v-model="themeConfig.lockScreenTime"
              controls-position="right"
              :min="1"
              :max="9999"
              @change="setLocalThemeConfig"
              size="small"
              style="width: 90px; margin-right: 1px"
            ></el-input-number>
          </div>
        </div>

        <!-- 界面显示 -->
        <el-divider content-position="center">界面显示</el-divider>
        <div class="setting-item mt15">
          <div class="setting-label">侧边栏 Logo</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isShowLogo"
              size="small"
              @change="onIsShowLogoChange"
            ></el-switch>
          </div>
        </div>
        <div
          class="setting-item mt15"
          :style="{
            opacity:
              themeConfig.layout === 'classic' ||
              themeConfig.layout === 'transverse'
                ? 0.5
                : 1,
          }"
        >
          <div class="setting-label">面包屑 Breadcrumb</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isBreadcrumb"
              :disabled="
                themeConfig.layout === 'classic' ||
                themeConfig.layout === 'transverse'
              "
              size="small"
              @change="onIsBreadcrumbChange"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">Breadcrumb 图标</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isBreadcrumbIcon"
              size="small"
              @change="setLocalThemeConfig"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">TagsView</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isTagsview"
              size="small"
              @change="setLocalThemeConfig"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">TagsView 图标</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isTagsviewIcon"
              size="small"
              @change="setLocalThemeConfig"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">TagsView 缓存</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isCacheTagsView"
              size="small"
              @change="setLocalThemeConfig"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">TagsView 拖拽</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isSortableTagsView"
              size="small"
              @change="onSortableTagsViewChange"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">TagsView 共用</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isShareTagsView"
              size="small"
              @change="onShareTagsViewChange"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">Footer 底部版权信息</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isFooter"
              size="small"
              @change="setLocalThemeConfig"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">灰色模式</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isGrayscale"
              size="small"
              @change="onAddFilterChange('grayscale')"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">色弱模式</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isInvert"
              size="small"
              @change="onAddFilterChange('invert')"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">开启水印</div>
          <div class="setting-value">
            <el-switch
              v-model="themeConfig.isWatermark"
              size="small"
              @change="onWatermarkChange"
            ></el-switch>
          </div>
        </div>
        <div class="setting-item mt14">
          <div class="setting-label">水印文案</div>
          <div class="setting-value">
            <el-input
              v-model="themeConfig.watermarkText"
              size="small"
              style="width: 90px; margin-right: 1px"
              @input="onWatermarkTextInput"
            ></el-input>
          </div>
        </div>

        <!-- 其它设置 -->
        <el-divider content-position="center">其它设置</el-divider>
        <div class="setting-item mt15">
          <div class="setting-label">TagsView 风格</div>
          <div class="setting-value">
            <el-select
              v-model="themeConfig.tagsStyle"
              placeholder="请选择"
              size="small"
              style="width: 90px; margin-right: 1px"
              @change="setLocalThemeConfig"
            >
              <el-option label="风格1" value="tags-style-one"></el-option>
              <el-option label="风格4" value="tags-style-four"></el-option>
              <el-option label="风格5" value="tags-style-five"></el-option>
            </el-select>
          </div>
        </div>
        <div class="setting-item mt15">
          <div class="setting-label">主页面切换动画</div>
          <div class="setting-value">
            <el-select
              v-model="themeConfig.animation"
              placeholder="请选择"
              size="small"
              style="width: 90px; margin-right: 1px"
              @change="setLocalThemeConfig"
            >
              <el-option label="slide-right" value="slide-right"></el-option>
              <el-option label="slide-left" value="slide-left"></el-option>
              <el-option label="opacitys" value="opacitys"></el-option>
              <el-option label="fade" value="fade"></el-option>
              <el-option label="fadeUp" value="fadeUp"></el-option>
              <el-option label="fadeDown" value="fadeDown"></el-option>
              <el-option label="fadeLeft" value="fadeLeft"></el-option>
              <el-option label="fadeRight" value="fadeRight"></el-option>
              <el-option
                label="lightSpeedLeft"
                value="lightSpeedLeft"
              ></el-option>
              <el-option
                label="lightSpeedRight"
                value="lightSpeedRight"
              ></el-option>
              <el-option label="zoom" value="zoom"></el-option>
              <el-option label="zoomUp" value="zoomUp"></el-option>
              <el-option label="zoomDown" value="zoomDown"></el-option>
              <el-option label="zoomLeft" value="zoomLeft"></el-option>
              <el-option label="zoomRight" value="zoomRight"></el-option>
              <el-option label="flip" value="flip"></el-option>
              <el-option label="flipX" value="flipX"></el-option>
              <el-option label="flipY" value="flipY"></el-option>
              <el-option label="backUp" value="backUp"></el-option>
              <el-option label="backDown" value="backDown"></el-option>
              <el-option label="backLeft" value="backLeft"></el-option>
              <el-option label="backRight" value="backRight"></el-option>
              <el-option label="bounce" value="bounce"></el-option>
              <el-option label="bounceUp" value="bounceUp"></el-option>
              <el-option label="bounceDown" value="bounceDown"></el-option>
              <el-option label="bounceLeft" value="bounceLeft"></el-option>
              <el-option label="bounceRight" value="bounceRight"></el-option>
            </el-select>
          </div>
        </div>
        <div
          class="setting-item mt15"
          :style="{ opacity: themeConfig.layout !== 'columns' ? 0.5 : 1 }"
        >
          <div class="setting-label">分栏高亮风格</div>
          <div class="setting-value">
            <el-select
              v-model="themeConfig.columnsAsideStyle"
              placeholder="请选择"
              size="small"
              style="width: 90px; margin-right: 1px"
              :disabled="themeConfig.layout !== 'columns'"
              @change="setLocalThemeConfig"
            >
              <el-option label="圆角" value="columns-round"></el-option>
              <el-option label="卡片" value="columns-card"></el-option>
            </el-select>
          </div>
        </div>
        <div
          class="setting-item mt15 mb27"
          :style="{ opacity: themeConfig.layout !== 'columns' ? 0.5 : 1 }"
        >
          <div class="setting-label">分栏布局风格</div>
          <div class="setting-value">
            <el-select
              v-model="themeConfig.columnsAsideLayout"
              placeholder="请选择"
              size="small"
              style="width: 90px; margin-right: 1px"
              :disabled="themeConfig.layout !== 'columns'"
              @change="setLocalThemeConfig"
            >
              <el-option label="水平" value="columns-horizontal"></el-option>
              <el-option label="垂直" value="columns-vertical"></el-option>
            </el-select>
          </div>
        </div>

        <!-- 布局切换 -->
        <el-divider content-position="center">布局切换</el-divider>
        <div class="layout-drawer-content-flex">
          <!-- defaults 布局 -->
          <div
            class="layout-drawer-content-item"
            @click="onSetLayout('defaults')"
          >
            <section
              class="el-container el-circular"
              :class="{
                'drawer-layout-active': themeConfig.layout === 'defaults',
              }"
            >
              <aside class="el-aside" style="width: 20px"></aside>
              <section class="el-container is-vertical">
                <header class="el-header" style="height: 10px"></header>
                <main class="el-main"></main>
              </section>
            </section>
            <div
              class="layout-tips-warp"
              :class="{
                'layout-tips-warp-active': themeConfig.layout === 'defaults',
              }"
            >
              <div class="layout-tips-box">
                <p class="layout-tips-txt">默认</p>
              </div>
            </div>
          </div>
          <!-- transverse 布局 -->
          <div
            class="layout-drawer-content-item"
            @click="onSetLayout('transverse')"
          >
            <section
              class="el-container is-vertical el-circular"
              :class="{
                'drawer-layout-active': themeConfig.layout === 'transverse',
              }"
            >
              <header class="el-header" style="height: 10px"></header>
              <section class="el-container">
                <section class="el-container is-vertical">
                  <main class="el-main"></main>
                </section>
              </section>
            </section>
            <div
              class="layout-tips-warp"
              :class="{
                'layout-tips-warp-active': themeConfig.layout === 'transverse',
              }"
            >
              <div class="layout-tips-box">
                <p class="layout-tips-txt">横向</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 一键操作 -->
        <div class="copy-config">
          <el-alert
            title="点击下方按钮，复制布局配置去代码中修改。"
            type="warning"
            :closable="false"
          ></el-alert>
          <el-button
            size="default"
            class="copy-config-btn"
            type="primary"
            @click="onCopyConfigClick"
          >
            <i class="el-icon-document-copy"></i>
            一键复制配置
          </el-button>
          <el-button
            size="default"
            class="copy-config-btn-reset"
            type="info"
            @click="onResetConfigClick"
          >
            <i class="el-icon-refresh"></i>
            一键恢复默认
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { Local, Session } from "@/utils/storage";
import { useChangeColor } from "@/utils/theme";
import watermark from "@/utils/watermark";
import { copyText } from "@/utils/commonFunction";

export default {
  name: "LayoutSettings",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawerVisible: false,
      themeConfig: {
        // 是否开启布局配置抽屉
        isDrawer: false,
        // 全局主题
        primary: "#0F59A4",
        isIsDark: false,
        // 顶栏设置
        topBar: "#FFFFFF",
        topBarColor: "#000000",
        isTopBarColorGradual: false,
        // 菜单设置
        menuBar: "#FFFFFF",
        menuBarColor: "#000000",
        isMenuBarColorGradual: false,
        // 分栏设置
        columnsMenuBar: "#2C3A49",
        columnsMenuBarColor: "#F0F0F0",
        isColumnsMenuBarColorGradual: false,
        isColumnsMenuHoverPreload: false,
        columnsLogoHeight: 50,
        columnsMenuWidth: 70,
        columnsMenuHeight: 50,
        // 界面设置
        isCollapse: false,
        isUniqueOpened: true,
        isFixedHeader: true,
        isFixedHeaderChange: false,
        isClassicSplitMenu: false,
        isLockScreen: false,
        lockScreenTime: 300,
        // 界面显示
        isShowLogo: true,
        isShowLogoChange: false,
        isBreadcrumb: true,
        isTagsview: true,
        isBreadcrumbIcon: true,
        isTagsviewIcon: true,
        isCacheTagsView: true,
        isSortableTagsView: true,
        isShareTagsView: true,
        isAllowCloseTagsView: false,
        isFooter: true,
        isGrayscale: false,
        isInvert: false,
        isWatermark: false,
        watermarkText: "快打分销", //水印的内容
        // 其它设置
        tagsStyle: "tags-style-one",
        animation: "fadeLeft",
        columnsAsideStyle: "columns-round",
        columnsAsideLayout: "columns-vertical",
        // 布局切换
        layout: "defaults",
        // 菜单高亮背景色
        menuBarActiveColor: "var(--el-color-primary-light-7)",
      },
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        // 确保 drawerVisible 与 visible prop 同步
        if (this.drawerVisible !== newVal) {
          this.drawerVisible = newVal;
        }
      },
      immediate: true,
    },
    drawerVisible(newVal) {
      // 确保 visible prop 与 drawerVisible 同步
      // 只有当值不同时才触发更新，避免循环
      if (this.visible !== newVal) {
        this.$emit("update:visible", newVal);
      }
    },
  },
  mounted() {
    this.loadThemeConfig();
    // 注意：不在mounted时初始化，而是在打开抽屉时或外部调用时初始化
  },
  methods: {
    // 加载主题配置
    loadThemeConfig() {
      const savedConfig = Local.get("themeConfig");
      if (savedConfig) {
        this.themeConfig = { ...this.themeConfig, ...savedConfig };
      }
    },
    // 初始化主题（参考BlueWhaleWeb的实现）
    initTheme() {
      this.$nextTick(() => {
        setTimeout(() => {
          // 应用主题颜色
          this.onColorPickerChange();
          // 应用顶栏和菜单颜色
          this.onBgColorPickerChange("topBar");
          this.onBgColorPickerChange("topBarColor");
          this.onBgColorPickerChange("menuBar");
          this.onBgColorPickerChange("menuBarColor");
          // 应用渐变效果
          this.onTopBarGradualChange();
          this.onMenuBarGradualChange();
          // 应用深色模式
          if (this.themeConfig.isIsDark) {
            this.onAddDarkChange();
          }
          // 应用灰色模式
          if (this.themeConfig.isGrayscale) {
            this.onAddFilterChange("grayscale");
          }
          // 应用色弱模式
          if (this.themeConfig.isInvert) {
            this.onAddFilterChange("invert");
          }
          // 应用水印
          if (this.themeConfig.isWatermark) {
            this.onWatermarkChange();
          }
          // 应用分栏设置
          this.onColumnsLogoHeightChange();
          this.onColumnsMenuWidthChange();
          this.onColumnsMenuHeightChange();
        }, 100);
      });
    },
    // 1、全局主题
    onColorPickerChange() {
      if (!this.themeConfig.primary) {
        this.$message.warning("全局主题 primary 颜色值不能为空");
        return;
      }
      const { getDarkColor, getLightColor } = useChangeColor();
      // 颜色加深
      document.documentElement.style.setProperty(
        "--el-color-primary-dark-2",
        `${getDarkColor(this.themeConfig.primary, 0.1)}`
      );
      document.documentElement.style.setProperty(
        "--el-color-primary",
        this.themeConfig.primary
      );
      // 颜色变浅
      for (let i = 1; i <= 9; i++) {
        document.documentElement.style.setProperty(
          `--el-color-primary-light-${i}`,
          `${getLightColor(this.themeConfig.primary, i / 10)}`
        );
      }
      this.setDispatchThemeConfig();
    },
    // 2、菜单 / 顶栏（参考BlueWhaleWeb的实现）
    onBgColorPickerChange(bg) {
      document.documentElement.style.setProperty(
        `--next-bg-${bg}`,
        this.themeConfig[bg]
      );
      if (bg === "menuBar") {
        const { getLightColor } = useChangeColor();
        document.documentElement.style.setProperty(
          `--next-bg-menuBar-light-1`,
          getLightColor(this.themeConfig.menuBar, 0.05)
        );
      }
      this.onTopBarGradualChange();
      this.onMenuBarGradualChange();
      this.onColumnsMenuBarGradualChange();
      this.setDispatchThemeConfig();
    },
    // 2、菜单 / 顶栏 --> 顶栏背景渐变
    onTopBarGradualChange() {
      this.setGraduaFun(
        ".top-header",
        this.themeConfig.isTopBarColorGradual,
        this.themeConfig.topBar
      );
    },
    // 2、菜单 / 顶栏 --> 菜单背景渐变
    onMenuBarGradualChange() {
      this.setGraduaFun(
        ".sidebar",
        this.themeConfig.isMenuBarColorGradual,
        this.themeConfig.menuBar
      );
      // 更新菜单背景色CSS变量
      document.documentElement.style.setProperty(
        "--el-menu-bg-color",
        document.documentElement.style.getPropertyValue("--next-bg-menuBar") ||
          this.themeConfig.menuBar
      );
      // 更新菜单组件
      this.$root.$emit("theme-config-changed", this.themeConfig);
    },
    // 2、菜单 / 顶栏 --> 分栏菜单背景渐变
    onColumnsMenuBarGradualChange() {
      // 分栏布局暂未实现，预留接口
    },
    // 2、菜单 / 顶栏 --> 背景渐变函数（参考BlueWhaleWeb的实现）
    setGraduaFun(el, bool, color) {
      this.$nextTick(() => {
        setTimeout(() => {
          const els = document.querySelector(el);
          if (!els) return false;
          if (bool) {
            const { getLightColor } = useChangeColor();
            els.setAttribute(
              "style",
              `background: linear-gradient(to bottom, ${color}, ${getLightColor(
                color,
                0.5
              )})`
            );
          } else {
            // 移除内联样式，让CSS变量生效
            els.setAttribute("style", "");
          }
          this.setLocalThemeConfig();
        }, 300);
      });
    },
    // 2、分栏设置 -> 分栏菜单鼠标悬停预加载
    onColumnsMenuHoverPreloadChange() {
      this.setLocalThemeConfig();
    },
    // 2、分栏设置 -> 分栏Logo高度
    onColumnsLogoHeightChange() {
      document.documentElement.style.setProperty(
        "--el-columnsLogoHeight",
        `${this.themeConfig.columnsLogoHeight}px`
      );
      this.setLocalThemeConfig();
    },
    // 2、分栏设置 -> 分栏菜单宽度
    onColumnsMenuWidthChange() {
      document.documentElement.style.setProperty(
        "--el-columnsMenuWidth",
        `${this.themeConfig.columnsMenuWidth}px`
      );
      document.documentElement.style.setProperty(
        "--el-columnsMenuRoundWidth",
        `${this.themeConfig.columnsMenuWidth - 5}px`
      );
      this.setLocalThemeConfig();
    },
    // 2、分栏设置 -> 分栏菜单高度
    onColumnsMenuHeightChange() {
      document.documentElement.style.setProperty(
        "--el-columnsMenuHeight",
        `${this.themeConfig.columnsMenuHeight}px`
      );
      document.documentElement.style.setProperty(
        "--el-columnsMenuRoundHeight",
        `${this.themeConfig.columnsMenuHeight - 5}px`
      );
      this.setLocalThemeConfig();
    },
    // 3、界面设置 --> 菜单水平折叠
    onThemeConfigChange() {
      this.$emit("collapse-change", this.themeConfig.isCollapse);
      this.setDispatchThemeConfig();
    },
    // 3、界面设置 --> 固定 Header
    onIsFixedHeaderChange() {
      this.themeConfig.isFixedHeaderChange = this.themeConfig.isFixedHeader
        ? false
        : true;
      this.setLocalThemeConfig();
    },
    // 3、界面设置 --> 经典布局分割菜单
    onClassicSplitMenuChange() {
      this.themeConfig.isBreadcrumb = false;
      this.setLocalThemeConfig();
      this.$root.$emit("getBreadcrumbIndexSetFilterRoutes");
    },
    // 4、界面显示 --> 侧边栏 Logo
    onIsShowLogoChange() {
      this.themeConfig.isShowLogoChange = this.themeConfig.isShowLogo
        ? false
        : true;
      this.setLocalThemeConfig();
      this.$root.$emit("logo-change", this.themeConfig.isShowLogo);
    },
    // 4、界面显示 --> 面包屑 Breadcrumb
    onIsBreadcrumbChange() {
      if (this.themeConfig.layout === "classic") {
        this.themeConfig.isClassicSplitMenu = false;
      }
      this.setLocalThemeConfig();
      this.$root.$emit("breadcrumb-change", this.themeConfig.isBreadcrumb);
    },
    // 4、界面显示 --> 开启 TagsView 拖拽
    onSortableTagsViewChange() {
      this.$root.$emit(
        "openOrCloseSortable",
        this.themeConfig.isSortableTagsView
      );
      this.setLocalThemeConfig();
    },
    // 4、界面显示 --> 开启 TagsView 共用
    onShareTagsViewChange() {
      this.$root.$emit("openShareTagsView", this.themeConfig.isShareTagsView);
      this.setLocalThemeConfig();
    },
    // 4、界面显示 --> 灰色模式/色弱模式
    onAddFilterChange(attr) {
      if (attr === "grayscale") {
        if (this.themeConfig.isGrayscale) {
          this.themeConfig.isInvert = false;
        }
      } else {
        if (this.themeConfig.isInvert) {
          this.themeConfig.isGrayscale = false;
        }
      }
      const cssAttr =
        attr === "grayscale"
          ? `grayscale(${this.themeConfig.isGrayscale ? 1 : 0})`
          : `invert(${this.themeConfig.isInvert ? "80%" : "0%"})`;
      const appEle = document.body;
      const currentStyle = appEle.getAttribute("style") || "";
      const filterMatch = currentStyle.match(/filter:\s*[^;]+/);
      if (filterMatch) {
        const newStyle = currentStyle.replace(
          /filter:\s*[^;]+/,
          `filter: ${cssAttr}`
        );
        appEle.setAttribute("style", newStyle);
      } else {
        appEle.setAttribute(
          "style",
          currentStyle
            ? `${currentStyle}; filter: ${cssAttr}`
            : `filter: ${cssAttr}`
        );
      }
      this.setLocalThemeConfig();
    },
    // 4、界面显示 --> 深色模式
    onAddDarkChange() {
      const body = document.documentElement;
      if (this.themeConfig.isIsDark) {
        body.setAttribute("data-theme", "dark");
      } else {
        body.setAttribute("data-theme", "");
      }
      this.setLocalThemeConfig();
    },
    // 4、界面显示 --> 开启水印
    onWatermarkChange() {
      if (this.themeConfig.isWatermark) {
        watermark.set(this.themeConfig.watermarkText);
      } else {
        watermark.del();
      }
      this.setLocalThemeConfig();
    },
    // 4、界面显示 --> 水印文案
    onWatermarkTextInput(val) {
      // 去除空格
      this.themeConfig.watermarkText = val.replace(/\s+/g, "");
      if (this.themeConfig.watermarkText === "") return false;
      if (this.themeConfig.isWatermark) {
        watermark.set(this.themeConfig.watermarkText);
      }
      this.setLocalThemeConfig();
    },
    // 5、布局切换
    onSetLayout(layout) {
      Local.set("oldLayout", layout);
      if (this.themeConfig.layout === layout) return false;
      if (layout === "transverse") {
        this.themeConfig.isCollapse = false;
      }
      this.themeConfig.layout = layout;
      this.themeConfig.isDrawer = false;
      this.drawerVisible = false;
      this.initLayoutChangeFun();
      this.$root.$emit("layout-change", layout);
    },
    // 设置布局切换函数
    initLayoutChangeFun() {
      this.onBgColorPickerChange("menuBar");
      this.onBgColorPickerChange("menuBarColor");
      this.onBgColorPickerChange("topBar");
      this.onBgColorPickerChange("topBarColor");
      this.onBgColorPickerChange("columnsMenuBar");
      this.onBgColorPickerChange("columnsMenuBarColor");
    },
    // 一键复制配置
    onCopyConfigClick() {
      const copyThemeConfig = Local.get("themeConfig");
      if (copyThemeConfig) {
        copyThemeConfig.isDrawer = false;
        copyText(JSON.stringify(copyThemeConfig, null, 2))
          .then(() => {
            this.$message.success("配置已复制到剪贴板");
            this.drawerVisible = false;
          })
          .catch(() => {
            this.$message.error("复制失败");
          });
      }
    },
    // 一键恢复默认
    onResetConfigClick() {
      this.$confirm(
        "确定要恢复默认配置吗？这将清除所有自定义设置并刷新页面。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          // 先保存需要保留的数据
          // access_token 是直接存储的字符串，不使用 Local.get/set
          const accessToken = localStorage.getItem("access_token");
          const scope = localStorage.getItem("scope"); // scope 存储在 localStorage
          const storeList = localStorage.getItem("storeList");
          const selectedShopIds = localStorage.getItem("selectedShopIds");

          console.log("保存的数据:", {
            accessToken: accessToken ? "存在" : "不存在",
            scope: scope ? "存在" : "不存在",
            storeList: storeList ? "存在" : "不存在",
            selectedShopIds: selectedShopIds ? "存在" : "不存在",
          });
          // 清除所有数据
          Local.clear();
          Session.clear();
          // 立即恢复需要保留的数据（在刷新前恢复）
          // access_token 是字符串，直接用 localStorage.setItem
          if (accessToken) {
            localStorage.setItem("access_token", accessToken);
          }
          if (scope) {
            localStorage.setItem("scope", scope); // scope 存储在 localStorage
          }
          if (storeList) {
            localStorage.setItem("storeList", storeList);
          }
          if (selectedShopIds) {
            localStorage.setItem("selectedShopIds", selectedShopIds);
          }
          // 使用 setTimeout 确保数据已保存后再刷新
          setTimeout(() => {
            window.location.reload();
          }, 100);
        })
        .catch(() => {
          // 用户取消
        });
    },
    // 触发 store 布局配置更新
    setDispatchThemeConfig() {
      this.setLocalThemeConfig();
      this.setLocalThemeConfigStyle();
    },
    // 存储布局配置
    setLocalThemeConfig() {
      Local.remove("themeConfig");
      Local.set("themeConfig", this.themeConfig);
      
      // 触发配置变化事件，通知其他组件实时更新
      this.$root.$emit("theme-config-changed");
    },
    // 存储布局配置全局主题样式（html根标签）
    setLocalThemeConfigStyle() {
      const cssText = document.documentElement.style.cssText;
      Local.set("themeConfigStyle", cssText);
      
      // 触发全局更新事件
      this.$root.$emit("theme-config-changed", this.themeConfig);
    },
    // 关闭弹窗
    handleClose(done) {
      this.themeConfig.isFixedHeaderChange = false;
      this.themeConfig.isShowLogoChange = false;
      this.themeConfig.isDrawer = false;
      // 调用 done 回调，允许 el-drawer 正常关闭
      if (typeof done === "function") {
        done();
      }
      // 同步状态
      this.drawerVisible = false;
      this.$emit("update:visible", false);
      // 保存配置
      this.setLocalThemeConfig();
    },
    // 打开抽屉（供外部调用）
    openDrawer() {
      // 先同步 visible prop
      if (!this.visible) {
        this.$emit("update:visible", true);
      }
      // 设置 drawerVisible
      this.drawerVisible = true;
      // 打开时初始化样式
      this.$nextTick(() => {
        setTimeout(() => {
          this.initTheme();
        }, 100);
      });
    },
    // 应用渐变效果（供外部调用，在DOM渲染后）
    applyGradients(savedConfig) {
      if (!savedConfig) return;
      this.$nextTick(() => {
        setTimeout(() => {
          if (savedConfig.isTopBarColorGradual && savedConfig.topBar) {
            const topHeader = document.querySelector(".top-header");
            if (topHeader) {
              const { getLightColor } = useChangeColor();
              topHeader.setAttribute(
                "style",
                `background: linear-gradient(to bottom, ${
                  savedConfig.topBar
                }, ${getLightColor(savedConfig.topBar, 0.5)})`
              );
            }
          }
          if (savedConfig.isMenuBarColorGradual && savedConfig.menuBar) {
            const sidebar = document.querySelector(".sidebar");
            if (sidebar) {
              const { getLightColor } = useChangeColor();
              sidebar.setAttribute(
                "style",
                `background: linear-gradient(to bottom, ${
                  savedConfig.menuBar
                }, ${getLightColor(savedConfig.menuBar, 0.5)})`
              );
            }
          }
        }, 100);
      });
    },
  },
};
</script>

<style scoped>
.layout-settings-content {
  padding: 0 15px;
  height: calc(100vh - 50px);
  overflow-y: auto;
}

.setting-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.setting-label {
  flex: 1;
  color: #606266;
  font-size: 14px;
}

.setting-value {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.mt10 {
  margin-top: 10px;
}

.mt11 {
  margin-top: 11px;
}

.mt14 {
  margin-top: 14px;
}

.mt15 {
  margin-top: 15px;
}

.mb27 {
  margin-bottom: 27px;
}

/* 布局切换样式 */
.layout-drawer-content-flex {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin: 0 -5px;
}

.layout-drawer-content-item {
  width: 50%;
  height: 70px;
  cursor: pointer;
  border: 1px solid transparent;
  position: relative;
  padding: 5px;
}

.layout-drawer-content-item .el-container {
  height: 100%;
}

.layout-drawer-content-item .el-aside-dark {
  background-color: #b3c0d1;
}

.layout-drawer-content-item .el-aside {
  background-color: #d3dce6;
}

.layout-drawer-content-item .el-header {
  background-color: #b3c0d1;
}

.layout-drawer-content-item .el-main {
  background-color: #e9eef3;
}

.el-circular {
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
}

.drawer-layout-active {
  border: 1px solid;
  border-color: var(--el-color-primary, #0f59a4);
}

.layout-tips-warp,
.layout-tips-warp-active {
  transition: all 0.3s ease-in-out;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid;
  border-color: var(--el-color-primary-light-5, rgba(15, 89, 164, 0.3));
  border-radius: 100%;
  padding: 4px;
}

.layout-tips-box {
  transition: inherit;
  width: 30px;
  height: 30px;
  z-index: 9;
  border: 1px solid;
  border-color: var(--el-color-primary-light-5, rgba(15, 89, 164, 0.3));
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.layout-tips-txt {
  font-size: 12px;
  color: var(--el-color-primary, #0f59a4);
  white-space: nowrap;
}

.layout-tips-warp-active {
  border-color: var(--el-color-primary, #0f59a4);
}

.layout-tips-warp-active .layout-tips-box {
  border-color: var(--el-color-primary, #0f59a4);
}

/* 一键操作样式 */
.copy-config {
  margin-top: 20px;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid #e4e7ed;
}

.copy-config-btn,
.copy-config-btn-reset {
  width: 100%;
  margin-top: 10px;
}

/* 修复配置的问题 */

.el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0px !important;
}
</style>

